"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Rate = _interopRequireDefault(require("./Rate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Rate["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-rate/lib/index.js
// module id = 624
// module chunks = 0